import React, { useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import { NavLink, useLocation, matchPath } from 'react-router';
import { useIntl } from 'react-intl';
import { BUILD_VERSION } from '../../configs';
import { sortLinksFunction } from '../../utils/layout-utils';
import { getPathNameWithOutParameters } from '../../utils/utils';
import { Icons } from '../base/BootstrapComponents/BootstrapComponents';

export default function Menu({ currentRoutesByMenu = [], defOpen = false }) {
  const [isOpen, setOpen] = useState(defOpen);
  const blockRef = useRef(null);
  const location = useLocation();
  const { formatMessage } = useIntl();
  const sortedRoutes = currentRoutesByMenu.sort(sortLinksFunction);

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside.bind(this));
    };
  });

  const handleClickOutside = event => {
    if (blockRef && (!blockRef.current || !blockRef.current.contains(event.target))) {
      setOpen(false);
    }
  };

  const renderMenuLink = (prop, key, isNested = true) => {
    if (prop.hideOnMenu || prop.redirect) {
      return null;
    }
    const { className = '', children = [], path = null } = prop;
    const isOpenGroup = !!children.find(route => matchPath(location.pathname, route.path || '')) || matchPath(location.pathname, prop.path || '');

    const isChildren = Boolean(children && children.length);
    const pathName = getPathNameWithOutParameters(path);
    const { MenuComponent = null, onlyComponent = false, afterContent = null } = prop;
    if (MenuComponent && onlyComponent) {
      return <MenuComponent key={key} prop={prop} isOpen={isOpen} />;
    }
    return (
      <div className={classNames('bd-toc-item', prop.className || '')} key={key}>
        <div className="menu-link-block">
          <NavLink className={classNames('menu-link', className, { 'parent-link': isChildren && isNested })} to={pathName} end={isChildren}>
            {isNested && <Icons className="menu-item-icon" icon={prop.icon} customIcon={!!prop.customIcon} />}
            {MenuComponent ? <MenuComponent prop={prop} isOpen={isOpenGroup} /> : <span className="nav-link-text">{formatMessage({ id: prop.name })}</span>}
            {isChildren && <div className="nested-arrow-wrapper"><Icons customIcon icon="arrow-down" className={classNames('nested-arrow', { open: isOpenGroup })} width={18} height={18} /></div>}
          </NavLink>
          {afterContent || null}
        </div>
        <ul className={classNames('nav nested sub-nav-group', { show: isChildren && isOpenGroup })}>
          {children.sort(sortLinksFunction).map((prop, key) => renderMenuLink(prop, key, false))}
        </ul>
      </div>
    );
  };

  return (
    <div className={classNames('app-left-column', { active: isOpen })} ref={blockRef}>
      <div
        className="toggle-button-wrapper"
        onClick={() => setOpen(!isOpen)}
      >
        <Icons customIcon className={classNames('toggle-button logo', { show: !isOpen })} icon="logo" />
        <Icons customIcon className={classNames('toggle-button logo-full', { show: isOpen })} icon="logo-full" />
        <div className="toggle-button toggle-arrow">
          <Icons
            customIcon
            className={classNames({ 'arrow-back': isOpen })}
            icon="arrow-forward"
          />
        </div>
      </div>
      <div className="app-menu custom-scroll-theme">
        <nav className="bd-links">
          <ul className="nav">
            {sortedRoutes.map(renderMenuLink)}
            <div className="menu-hr" />
            <div className="version-number">{BUILD_VERSION}</div>
          </ul>
        </nav>
      </div>
    </div>
  );
}
